import React from 'react';

interface Props {
  classname: string;
}

export class ContextualButtonUnselectedIcon extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <path
          className={this.props.classname}
          d="M6.444 12.889A6.444 6.444 0 1 1 6.444 0a6.444 6.444 0 0 1 0 12.889zm0-2a4.444 4.444 0 1 0 0-8.889 4.444 4.444 0 0 0 0 8.889zm4.738 1.707l1.414-1.414 3.111 3.11-1.414 1.415-3.111-3.111z"
        />
      </svg>
    );
  }
}
